// Material
import { Divider } from '@mui/material'
// Logic
import { Subscriber } from '@weblite/ts-action/subscription'
import {
  useHallNonAdminSubscribers,
  useSearchedHallNonAdminSubscribers,
} from '$logic/subscription/react-hook'
// Common
import {
  UserListItemSkeleton,
  UserListItemWithStatus,
} from '$common/user-list-item'
import { EmptyStateList } from '$common/empty-state-list'
import { withSearchableInfiniteListPage } from '$common/searchable-list-page'
import {
  closeAddHallAdmin,
  openDefineChannelAdminPermissions,
  openDefineGroupAdminPermissions,
} from '$logic/router'
import { getRoom } from '$logic/room'
import { t } from '$i18n'

const ListItem = ({ id, roomId }: { id: string; roomId: string }) => (
  <>
    <UserListItemWithStatus
      userId={id}
      hasDivider={false}
      onClick={async () => {
        const room = await getRoom(roomId)
        if (!room) return
        if (room.type === 'CHANNEL')
          openDefineChannelAdminPermissions(roomId, id)
        else openDefineGroupAdminPermissions(roomId, id)
      }}
    />
    <Divider variant="inset" />
  </>
)

interface SearchParams {
  roomId: string
  query: string
  fetchedItems: Subscriber[]
  hasMoreItemToLoad: boolean
}

const Page = withSearchableInfiniteListPage<Subscriber, string, SearchParams>({
  appBarTitle: t('addAdmin.title'),
  SkeletonItem: UserListItemSkeleton,
  EmptyStateComponent: () => <EmptyStateList />,
  fetchHook: useHallNonAdminSubscribers,
  searchHook: useSearchedHallNonAdminSubscribers,
  onBack: closeAddHallAdmin,
})

export function AddAdmin({ roomId }: { roomId: string }) {
  return (
    <Page
      fetchHookParams={roomId}
      getSearchHookParams={(query, items, hasMoreItemToLoad) => ({
        query,
        fetchedItems: items,
        hasMoreItemToLoad,
        roomId,
      })}
      ListItem={item => <ListItem id={item.id} roomId={roomId} />}
    />
  )
}
